export const brown = {
  1: { value: { base: '{colors.brown.light.1}', _dark: '{colors.brown.dark.1}' } },
  2: { value: { base: '{colors.brown.light.2}', _dark: '{colors.brown.dark.2}' } },
  3: { value: { base: '{colors.brown.light.3}', _dark: '{colors.brown.dark.3}' } },
  4: { value: { base: '{colors.brown.light.4}', _dark: '{colors.brown.dark.4}' } },
  5: { value: { base: '{colors.brown.light.5}', _dark: '{colors.brown.dark.5}' } },
  6: { value: { base: '{colors.brown.light.6}', _dark: '{colors.brown.dark.6}' } },
  7: { value: { base: '{colors.brown.light.7}', _dark: '{colors.brown.dark.7}' } },
  8: { value: { base: '{colors.brown.light.8}', _dark: '{colors.brown.dark.8}' } },
  9: { value: { base: '{colors.brown.light.9}', _dark: '{colors.brown.dark.9}' } },
  10: { value: { base: '{colors.brown.light.10}', _dark: '{colors.brown.dark.10}' } },
  11: { value: { base: '{colors.brown.light.11}', _dark: '{colors.brown.dark.11}' } },
  12: { value: { base: '{colors.brown.light.12}', _dark: '{colors.brown.dark.12}' } },
  a1: { value: { base: '{colors.brown.light.a1}', _dark: '{colors.brown.dark.a1}' } },
  a2: { value: { base: '{colors.brown.light.a2}', _dark: '{colors.brown.dark.a2}' } },
  a3: { value: { base: '{colors.brown.light.a3}', _dark: '{colors.brown.dark.a3}' } },
  a4: { value: { base: '{colors.brown.light.a4}', _dark: '{colors.brown.dark.a4}' } },
  a5: { value: { base: '{colors.brown.light.a5}', _dark: '{colors.brown.dark.a5}' } },
  a6: { value: { base: '{colors.brown.light.a6}', _dark: '{colors.brown.dark.a6}' } },
  a7: { value: { base: '{colors.brown.light.a7}', _dark: '{colors.brown.dark.a7}' } },
  a8: { value: { base: '{colors.brown.light.a8}', _dark: '{colors.brown.dark.a8}' } },
  a9: { value: { base: '{colors.brown.light.a9}', _dark: '{colors.brown.dark.a9}' } },
  a10: { value: { base: '{colors.brown.light.a10}', _dark: '{colors.brown.dark.a10}' } },
  a11: { value: { base: '{colors.brown.light.a11}', _dark: '{colors.brown.dark.a11}' } },
  a12: { value: { base: '{colors.brown.light.a12}', _dark: '{colors.brown.dark.a12}' } },
}
